import { jsPDF } from "jspdf";
// import * as pdfjsLib from "pdfjs-dist";
import axios from "axios";
var pdfjsLib = window.pdfjsLib;

// pdfjsLib.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.mjs`;
export default class MyPdf {
  async loadFont(url) {
    try {
      const response = await fetch(url);
      console.log(
        `Font fetch status for ${url}:`,
        response.status,
        response.ok,
      );
      if (!response.ok) {
        throw new Error(`Failed to load font from URL: ${response.statusText}`);
      }
      const arrayBuffer = await response.arrayBuffer();
      const binaryString = this.arrayBufferToBinaryString(arrayBuffer);
      return binaryString;
    } catch (error) {
      console.error("Error loading font:", error);
      throw error;
    }
  }

  arrayBufferToBinaryString(buffer) {
    var binary = "";
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return binary;
  }

  async convertImageToBase64ByUrl(url) {
    try {
      const { data } = await axios.post(
        "/api/download",
        {
          url: url,
        },
        {
          responseType: "arraybuffer",
        },
      );
      const blob = new Blob([data], { type: "image/jpeg" });

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          if (reader.result) {
            resolve(reader.result.toString());
          } else {
            reject(new Error("Failed to convert image to base64"));
          }
        };
        reader.onerror = () => {
          reject(new Error("Failed to convert image to base64"));
        };
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      return "";
    }
  }

  async convertImageToBase64ByAsset(path) {
    try {
      const response = await fetch(path);
      if (!response.ok) {
        return "";
      }
      console.log("response22====", response);
      const blob = await response.blob();
      console.log("blob22====", blob);
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          if (reader.result) {
            resolve(reader.result.toString());
          } else {
            reject(new Error("Failed to convert image to base64"));
          }
        };
        reader.onerror = () => {
          reject(new Error("Failed to convert image to base64"));
        };
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Error converting image to base64:", error);
      return "";
    }
  }

  async generatePdf(
    entranceCode,
    roomName,
    profileUrl,
    prefix,
    firstName,
    lastName,
    dateOfBirth,
    bornVillage,
    bornDistrict,
    bornProvince,
    group,
    examDate,
    approvedAt,
  ) {
    const logoBase64 = await this.convertImageToBase64ByAsset(
      "/assets/logo-ministry.png",
    );
    const sealBase64 = await this.convertImageToBase64ByAsset(
      "/assets/entrance-license.png",
    );

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    // Custom Lao font
    const fontUrl = "/assets/font/PhetsarathOT.ttf";
    const saysettha = await this.loadFont(fontUrl);
    doc.addFileToVFS("PhetsarathOT.ttf", saysettha);
    doc.addFont("PhetsarathOT.ttf", "phetsaraot", "normal");
    doc.setFont("phetsaraot");

    // White background
    doc.setFillColor(255, 255, 255);
    doc.rect(
      0,
      0,
      doc.internal.pageSize.getWidth(),
      doc.internal.pageSize.getHeight(),
      "F",
    );
    doc.setTextColor(0, 0, 0);

    // ---------- helpers ----------
    function centerTextBlock(text, xStart, xEnd, y) {
      const textWidth =
        (doc.getStringUnitWidth(text) * doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      const startX = xStart + (xEnd - xStart - textWidth) / 2;
      doc.text(text, startX, y);
    }

    function addCenteredText(text, x, y, width, height) {
      const textWidth =
        (doc.getStringUnitWidth(text) * doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      const textHeight =
        doc.internal.getLineHeight() / doc.internal.scaleFactor;
      const startX = x + (width - textWidth) / 2;
      const startY = y + (height - textHeight) / 2 + textHeight;
      doc.text(text, startX, startY - 1);
    }

    // Draws a text segment and returns its width, so segments can be chained horizontally
    function addTextSegment(doc, text, x, y, options = {}) {
      const { color = [0, 0, 0], underline = false, padding = 0 } = options;

      const segmentStartX = x; // where padding begins
      const textStartX = x + padding; // where the actual text starts
      const textWidth =
        (doc.getStringUnitWidth(text) * doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      const segmentEndX = textStartX + textWidth + padding; // where padding ends

      doc.setTextColor(color[0], color[1], color[2]);
      doc.text(text, textStartX, y);

      if (underline) {
        doc.setDrawColor(color[0], color[1], color[2]);
        doc.setLineWidth(0.2);
        doc.setLineDashPattern([0.6, 0.6], 0);
        // line now spans the FULL padded width, not just the text width
        doc.line(segmentStartX, y + 1, segmentEndX, y + 1);
        doc.setLineDashPattern([], 0);
      }

      // total horizontal space consumed by this segment
      return segmentEndX - segmentStartX;
    }

    function drawCheckmark(doc, x, y, size = 3) {
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.4);
      // short down-stroke
      doc.line(x, y - size * 0.3, x + size * 0.35, y);
      // long up-stroke
      doc.line(x + size * 0.35, y, x + size, y - size * 0.8);
    }

    // ---------- 1. Student photo (top-left) ----------
    const photoWidth = 30;
    const photoHeight = 39;
    const photoX = 15;
    const photoY = 24;
    doc.setDrawColor(0);
    doc.setLineWidth(0.2);
    doc.rect(photoX, photoY, photoWidth, photoHeight);
    if (profileUrl) {
      doc.addImage(profileUrl, "JPEG", photoX, photoY, photoWidth, photoHeight);
    }

    // ---------- 2. Header (centered, republic name) ----------
    doc.setFontSize(13);
    doc.setFont("phetsaraot", "normal");
    centerTextBlock(
      "ສາທາລະນະລັດ ປະຊາທິປະໄຕ ປະຊາຊົນລາວ",
      photoX + photoWidth,
      174,
      22,
    );
    doc.setFontSize(13);
    centerTextBlock(
      "ສັນຕິພາບ ເອກະລາດ ປະຊາທິປະໄຕ ເອກະພາບ ວັດທະນາຖາວອນ",
      photoX + photoWidth,
      174,
      28,
    );

    // ---------- 3. Exam room (top-right) ----------
    doc.setFontSize(11);
    doc.setTextColor(50, 50, 50);
    doc.text(`ຫ້ອງສອບເສັງ: `, 168, 34);
    doc.setTextColor(0, 102, 204);
    doc.text(`${roomName || ""}`, 188, 34);

    // ---------- 4. Ministry / committee (left) ----------
    doc.setFontSize(10);
    doc.setTextColor(50, 50, 50);
    doc.text("ກະຊວງສຶກສາທິການ ແລະ ກິລາ", photoX + photoWidth + 3, 42);
    doc.text("ຄະນະກຳມະການສອບເສັງ", photoX + photoWidth + 3, 49);

    // ---------- 5. Entrance code boxes (right) ----------
    doc.setTextColor(0, 0, 0);
    doc.text("ເລກທີ:", 155, 42);
    const codeChars = (entranceCode || "").toString().split("");
    const boxSizeX = 8;
    const boxSizeY = 6;
    let boxX = 166;
    const boxY = 38;
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.3);
    doc.setTextColor(0, 102, 204);
    codeChars.forEach((char) => {
      doc.rect(boxX, boxY, boxSizeX, boxSizeY);
      addCenteredText(char, boxX, boxY, boxSizeX, boxSizeY);
      boxX += boxSizeX;
    });
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(8);
    doc.text("(ສຳລັບພະນັກງານລົງທະບຽນ)", 168, 49);

    // ---------- 6. Committee head line (centered, bold) ----------
    doc.setFontSize(12);
    doc.setFont("phetsaraot", "normal");
    const headLine = `ຫົວໜ້າຄະນະກຳມະການສອບເສັງຄັດເລືອກເອົານັກຮຽນເຂົ້າຮຽນຕໍ່ທີ່ ມະຫາວິທະຍາໄລ ຈຳປາສັກ`;
    const headLineWidth =
      (doc.getStringUnitWidth(headLine) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    const pageWidth = doc.internal.pageSize.getWidth();
    doc.text(headLine, (pageWidth - headLineWidth) / 2 + 11, 60);

    // ---------- 7. Student info paragraph ----------
    let y = 74;
    const leftMargin = 15;
    const lineHeight = 8;
    const BLUE = [0, 102, 204];
    const BLACK = [0, 0, 0];
    const VALUE_PADDING = 2; // mm of breathing room around each filled-in value

    doc.setFontSize(11);

    // --- Line 1 ---
    let x = leftMargin;
    x += addTextSegment(doc, "ອະນຸຍາດໃຫ້ ທ້າວ/ນາງ: ", x, y, { color: BLACK });
    x += addTextSegment(doc, `${prefix || ""} ${firstName || ""}`, x, y, {
      color: BLUE,
      underline: true,
      padding: VALUE_PADDING,
    });
    x += addTextSegment(doc, ", ນາມສະກຸນ: ", x, y, { color: BLACK });
    x += addTextSegment(doc, `${lastName || ""}`, x, y, {
      color: BLUE,
      underline: true,
      padding: VALUE_PADDING,
    });
    x += addTextSegment(doc, ", ອາຍຸ,ເດືອນ,ປີເກີດ:", x, y, { color: BLACK });

    x += addTextSegment(doc, `${dateOfBirth || ""}`, x, y, {
      color: BLUE,
      underline: true,
      padding: VALUE_PADDING,
    });

    // --- Line 2 ---

    y += lineHeight;
    x = leftMargin;
    x += addTextSegment(doc, "ບ້ານເກີດ: ", x, y, { color: BLACK });
    x += addTextSegment(doc, `${bornVillage || ""}`, x, y, {
      color: BLUE,
      underline: true,
      padding: VALUE_PADDING,
    });
    x += addTextSegment(doc, ", ເມືອງ: ", x, y, { color: BLACK });
    x += addTextSegment(doc, `${bornDistrict || ""}`, x, y, {
      color: BLUE,
      underline: true,
      padding: VALUE_PADDING,
    });
    x += addTextSegment(doc, ", ແຂວງ: ", x, y, { color: BLACK });
    x += addTextSegment(doc, `${bornProvince || ""}`, x, y, {
      color: BLUE,
      underline: true,
      padding: VALUE_PADDING,
    });

    doc.setTextColor(0, 0, 0);

    // ---------- 8. Exam track A/B checkbox ----------
    y += lineHeight + 2;
    doc.text("ມີຈຸດປະສົງສະໝັກເຂົ້າສອບເສັງສາຍ (ໝາຍ", leftMargin, y);
    const textWidthBefore =
      (doc.getStringUnitWidth("ມີຈຸດປະສົງສະໝັກເຂົ້າສອບເສັງສາຍ (ໝາຍ") *
        doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    drawCheckmark(doc, leftMargin + textWidthBefore + 2, y);
    doc.text("ໃສ່ບ໋ອກ):", leftMargin + textWidthBefore + 6, y);

    function checkbox(x, checked) {
      doc.setDrawColor(0);
      doc.setLineWidth(0.2);
      doc.rect(x, y - 4, 5, 5);
      if (checked) {
        drawCheckmark(doc, x + 0.7, y, 3.5);
      }
    }
    checkbox(100, group === "A");
    doc.text("ສາຍ A", 107, y);
    checkbox(135, group === "B");
    doc.text("ສາຍ B", 142, y);

    // ---------- 9. Exam center checkbox ----------
    y += lineHeight;
    doc.text("ທີ່ສູນສອບເສັງ (ສໍາລັບພະນັກງານ):", leftMargin, y);

    checkbox(85, true);
    doc.text(`ມະຫາວິທະຍາໄລ ຈຳປາສັກ`, 92, y);

    // ---------- 10. Exam date ----------
    y += lineHeight;
    doc.setFont("phetsaraot", "normal");
    doc.text(`ສອບເສັງວັນທີ: ${examDate || ""}`, leftMargin, y);

    // ---------- 11. Notes ----------
    y += lineHeight;
    doc.text("ໝາຍເຫດ:", leftMargin, y);
    y += lineHeight - 2;
    doc.text("- ຫ້າມນຳໃຊ້ເຄື່ອງມືສື່ສານທຸກປະເພດເປັນເດັດຂາດ", leftMargin + 5, y);
    y += lineHeight - 3;
    doc.text("- ນຳໃຊ້ສໍດຳເທົ່ານັ້ນໃນການສອບເສັງ", leftMargin + 5, y);
    y += lineHeight - 3;
    doc.text(
      "- ອາຄານສອບເສັງ...................................",
      leftMargin + 5,
      y,
    );

    // ---------- 12. Signature / seal block (bottom-right) ----------
    // const signDate = approvedAt ? new Date(approvedAt) : new Date();
    // doc.text(
    //   `ທີ...................., ວັນທີ...../...../${signDate.getFullYear()}`,
    //   120,
    //   y + 15,
    // );
    // doc.text("ຜູ້ອຳນວຍການ", 155, y + 22);
    // doc.setFontSize(9);
    // doc.text("(ຫົວໜ້າຄະນະກຳມະການສອບເສັງ)", 130, y + 27);
    // doc.setFontSize(11);

    if (sealBase64) {
      doc.addImage(sealBase64, "PNG", 110, y - 6, 84, 60);
    }

    return doc.output("blob");
  }

  convertPDFToImage = async (pdfBlob) => {
    // Convert Blob to ArrayBuffer
    const arrayBuffer = await pdfBlob.arrayBuffer();
    console.log("arrayBuffer...", arrayBuffer);

    console.log("000000========000000");
    // Load PDF
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    const page = await pdf.getPage(1);
    console.log("11111========11111");

    const viewport = page.getViewport({ scale: 1.5 });
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    canvas.height = viewport.height;
    canvas.width = viewport.width;

    const renderContext = {
      canvasContext: context,
      viewport: viewport,
    };

    await page.render(renderContext).promise;

    const base64Image = canvas.toDataURL();
    return base64Image;
  };

  // async convertPdfToImage(pdfBlob) {
  //   // Convert Blob to ArrayBuffer
  //   const arrayBuffer = await pdfBlob.arrayBuffer();
  //   var bytes = new Uint8Array(arrayBuffer); //use this if data is raw bytes else directly pass resData
  //   var blob = new window.Blob([bytes], { type: "application/pdf" });
  //   var fileURL = URL.createObjectURL(blob);
  //   //win.document.write('<iframe src="' + fileURL + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>')

  //   return fileURL;
  // }
}
